import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
    errorMessage: {
        color: 'var(--red)',
        scrollMarginTop: '100px'
    }
}))
